import { StrictRouteConfig } from "@/router/router";

export const officeRoutes: StrictRouteConfig[] = [
    {
        path: "/customers/:customerId/offices",
        name: "offices",
        component: () => import(/* webpackChunkName: "office" */ "@/views/office/offices.vue"),
        meta: {
            requiresAuth: true,
            label: "Offices",
            title: "Manage offices",
            includeInNavigation: true,
            icon: "briefcase-outline",
            matchExact: true,
            path: ["dashboard", "offices"],
            order: 30,
        },
    },
    {
        path: "/customers/:customerId/offices/:officeId/overview",
        name: "office-overview",
        component: () => import(/* webpackChunkName: "office" */ "@/views/office/office-overview.vue"),
        meta: {
            requiresAuth: true,
            label: "Office overview",
            includeInNavigation: false,
            icon: "briefcase-outline",
            matchExact: true,
            path: ["dashboard", "offices", "office-overview"],
            includeInSubNavigation: true,
            order: 10,
        },
    },
    {
        path: "/customers/:customerId/offices/:officeId",
        name: "office",
        component: () => import(/* webpackChunkName: "office" */ "@/views/office/office.vue"),
        meta: {
            requiresAuth: true,
            label: "Office settings",
            includeInNavigation: false,
            icon: "briefcase-outline",
            matchExact: true,
            path: ["dashboard", "offices", "office"],
            includeInSubNavigation: true,
            order: 10,
        },
    },
];
